<div class="overlay3"
     (click)="onClose($event)"></div>

<article class="msg-popup-group">

  <div class="msg-box">

    <div class="tit-box"
         *ngIf="config && !IsEmptyString(config.title)"
         [innerHTML]="config.title | resize">
    </div>

    <div class="img-box"
         *ngIf="config && !IsEmptyString(config.image)">
      <img src="{{ config.image }}" alt="이미지">
    </div>

    <div class="txt-box"
         [innerHTML]="config.msg | resize">
    </div>

  </div>

  <div class="msg-menu-box">

    <a class="menu-btn type-1"
       *ngIf="config && !IsEmptyString(config.btnCancel)"
       (click)="clickBtn.emit(MP_RESULT.CANCEL)">{{ config.btnCancel }}</a>
    <a class="menu-btn type-2"
       *ngIf="config && !IsEmptyString(config.btnError)"
       (click)="clickBtn.emit(MP_RESULT.ERROR)">{{ config.btnError }}</a>
    <a class="menu-btn type-3"
       *ngIf="config && !IsEmptyString(config.btnOk)"
       (click)="clickBtn.emit(MP_RESULT.OK)">{{ config.btnOk }}</a>

  </div>
</article>
